var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\">\r\n  <path d=\"M1 13.8529H15L8 1.5L1 13.8529ZM8.82353 12.2059H7.17647V10.5588H8.82353V12.2059ZM8.82353 9.73529H7.17647V6.44118H8.82353V9.73529Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol